export enum DeliveryPalletsControlNames {
  OptionsSeat = 'OptionsSeat',
  SeatsAmount = 'SeatsAmount',
  RowCost = 'RowCost'
}
